import {ChangeDetectionStrategy, Component, OnChanges, OnInit, input} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';

@Component({
    selector: 'esp-additions-datatable',
    templateUrl: './additions-datatable.component.html',
    styleUrls: ['./additions-datatable.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        TranslateModule,
    ]
})
export class AdditionsDatatableComponent implements OnChanges {

    total = 0;
    displayedColumns: string[] = ['name', 'value'];
    readonly dataSource = input<{
    name: string;
    value: number;
}[]>(undefined);

    constructor() {}

    ngOnChanges(): void {
        const dataSource = this.dataSource();
        if (dataSource && dataSource.length > 0) {
            this.total = dataSource.map(row => row.value).reduce((a,b) => {return a + b; });
        }
    }



}
